module.exports = __webpack_public_path__ + "static/media/two-image-car.c8802dfb.png";